
<div class="login-bg align-items-center">
  
    <div class="row w-100">
      <div class="col-lg-6 d-flex">
        <div class="auth-logo m-auto">
          <img src="assets/images/admin-logo-v2.png" class="img-fluid" alt="" />
        </div>
      </div>
      <div class="col-lg-6">
        <div class="splash-container login-wrap d-flex align-items-center">
          <div class="card px-2 py-5 mb-0">
        
          <div class="card-body">
            <div class="headbox text-center">
              <h1>Sign In</h1>
              <span class="splash-description">Please enter your user information.</span>
            </div>  
            <div class="alert alert-danger" *ngIf="incorrect && message">
              <button mat-button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <i class="material-icons">close</i>
              </button>
              <span>{{ message }}</span>
            </div>
            <div class="middle-area">
              <div id="buttonDiv"></div> 

              <button class="btn btn-lg btn-block btn-outline-default mb-4" (click)="signInWithGoogle()">
                <img src="assets/images/g-icon.png" class="img-fluid mr-1" alt="" /> Sign in with Google</button>
  
              <div class="sparate mb-5"><span>Or with email</span></div>
  
              <form class="" [formGroup]="registerForm" (ngSubmit)="onSubmit()">
              <div class="form-group mb-4">
                <input type="email" class="form-control form-control-lg" formControlName="email" placeholder="Email" [ngClass]="{ 'is-invalid': submitted && f['email']['errors'] }" required>
                <div *ngIf="submitted && f['email']?.errors" class="invalid-feedback">
                  <div *ngIf="f['email'].errors?.['required']">Email is required</div>
                  <div *ngIf="f['email'].errors?.['email'] || f['email'].errors?.['pattern']">Email must be a valid email address</div>
                </div>
              </div>
              <div class="form-group mb-3 position-relative">
                <input type="{{pwdType ? 'password' : 'text'}}" class="form-control form-control-lg" formControlName="password" placeholder="Password" [ngClass]="{ 'is-invalid': submitted && f['password']['errors'] }" required>
                <div class="eye-icon" (click)="togglePwdType()" style="cursor: pointer;">
                  <span class="material-symbols-sharp">{{pwdType ? 'visibility_off' : 'visibility'}}</span>
                </div>
                <div *ngIf="submitted && f['password']?.errors" class="invalid-feedback">
                  <div *ngIf="f['password'].errors?.['required']">Password is required</div>
                  <div *ngIf="f['password'].errors?.['minlength']">Password must be at least 6 characters</div>
                </div>
              </div>
              <div class="form-group position-relative text-right mb-4">
                <a routerLink="/verify-email" class="red-link">Forgot Password</a>
              </div>
              <div class="btn-wrap text-center mt-5">
                <button mat-raised-button type="submit" class="btn btn-lg btn-block btn-primary">Sign In</button>
              </div>
              </form>
            </div>
          </div>
          <div class="card-footer bg-white pt-3 d-flex">
              <div class="card-footer-item card-footer-item-bordered">Not a Member yet?
                  <a routerLink="/register" routerLinkActive="active" class="red-link">Create An Account</a></div>
              <!-- <div class="card-footer-item card-footer-item-bordered">
                  <a href="#" class="footer-link">Forgot Password</a>
              </div> -->
          </div>
        </div>
      </div>
      </div>
    </div>
  
</div>